var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "#FD3A57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C9.248 0.5 0.5 9.248 0.5 20C0.5 30.752 9.248 39.5 20 39.5C30.752 39.5 39.5 30.752 39.5 20C39.5 9.248 30.752 0.5 20 0.5ZM20 3.5C29.1305 3.5 36.5 10.8695 36.5 20C36.5 29.1305 29.1305 36.5 20 36.5C10.8695 36.5 3.5 29.1305 3.5 20C3.5 10.8695 10.8695 3.5 20 3.5ZM14.33 12.17L12.17 14.33L17.846 20L12.173 25.67L14.333 27.83L20 22.1555L25.67 27.8255L27.83 25.67L22.1555 20L27.8255 14.33L25.67 12.17L20 17.846L14.33 12.173V12.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.3fae4272.svg";
export { ForwardRef as ReactComponent };